import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Modal,
  Skeleton,
  Spin,
  Result,
  Divider,
  Select,
  Radio,
  DatePicker,
  Checkbox,
} from "antd";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../store";
import {
  getLevelRequest,
  resetSuccessLevel,
  resetMessageLevel,
} from "../slices/level"; // Sesuaikan dengan nama slice level
import { LoadingOutlined } from "@ant-design/icons";
import { redirect, useParams } from "react-router-dom";
import { detailEmployeeRequest, getEmployeeRequest } from "../slices/employee";
import { getDepartmentRequest } from "../slices/department";
import { getBranchRequest } from "../slices/branch";
import dayjs from "dayjs";
import {
  resetJobMessage,
  resetJobSuccess,
  updateJobRequest,
} from "../slices/job";
import {
  resetPersonMessage,
  resetPersonSuccess,
  updatePersonRequest,
} from "../slices/person";
import {
  resetContactMessage,
  resetContactSuccess,
  updateContactRequest,
} from "../slices/contact";
import {
  resetBenefitMessage,
  resetBenefitSuccess,
  updateBenefitRequest,
} from "../slices/benefit";
import { getOrganisationRequest } from "../slices/organisation";

const DetailEmployee: React.FC = () => {
  const [FormPerson] = Form.useForm();
  const [FormJob] = Form.useForm();
  const [FormContact] = Form.useForm();
  const [FormBenefit] = Form.useForm();
  const { eid } = useParams<{ eid: string }>();
  const dispatch = useDispatch();

  const [isEditing, setIsEditing] = useState(false);
  const [editingLevel, setEditingLevel] = useState<any>(null);
  const [openModal, setOpenModal] = useState(false);
  const [formActive, setFormActive] = useState<string>("");
  const [updateField, setUpdateField] = useState<any>(null);
  const [buttonHide, setButtonHide] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const {
    isLoading,
    loading,
    detailEmployee,
    message,
    isLogin,
    department,
    level,
    branchs,
    organisations,
    employees,
    jobMessage,
    jobChange,
    jobSuccess,
    jobLoading,
    personChange,
    personSuccess,
    personMessage,
    contactChange,
    contactSuccess,
    contactMessage,
    benefitChange,
    benefitSuccess,
    benefitMessage,
  } = useTypedSelector((state) => ({
    isLoading:
      state.Job.pageIsLoading ||
      state.Person.pageIsLoading ||
      state.Contact.pageIsLoading ||
      state.Benefit.pageIsLoading,
    loading: state.Employee.pageIsLoading,
    detailEmployee: state.Employee.detailEmployee,
    message:
      state.Employee.message ||
      state.Benefit.message ||
      state.Contact.message ||
      state.Person.message ||
      state.Job.message,
    isLogin: state.Auth.isLogin,
    department: state.Department.departmentList,
    level: state.Level.levelList,
    branchs: state.Branch.branchList,
    employees: state.Employee.employeePersonList,
    jobMessage: state.Job.message,
    jobChange: state.Job.jobUpdate,
    jobSuccess: state.Job.isSuccess,
    jobLoading: state.Job.pageIsLoading,
    personChange: state.Person.personUpdate,
    personSuccess: state.Person.isSuccess,
    personLoading: state.Person.pageIsLoading,
    personMessage: state.Person.message,
    contactChange: state.Contact.contactUpdate,
    contactSuccess: state.Contact.isSuccess,
    contactLoading: state.Contact.pageIsLoading,
    contactMessage: state.Contact.message,
    benefitChange: state.Benefit.benefitUpdate,
    benefitSuccess: state.Benefit.isSuccess,
    benefitLoading: state.Benefit.pageIsLoading,
    benefitMessage: state.Benefit.message,
    organisations: state.Organisation.organisationList
  }));

  const locationData = branchs;
  const organisationData = organisations;
  const approvalData = employees;
  const levelData = level;
  const departmentData = department;

  console.log("EEEEEEE", organisationData);

  useEffect(() => {
    if (!isLogin) {
      redirect("/login");
    } else {
      dispatch(detailEmployeeRequest({ _id: eid }) as any);
      dispatch(getLevelRequest() as any);
      dispatch(getDepartmentRequest() as any);
      dispatch(getOrganisationRequest() as any);
      dispatch(getBranchRequest() as any);
      dispatch(getEmployeeRequest() as any);
    }
  }, []);
  console.log("BEN1", contactSuccess);
  console.log("BEN2", jobSuccess);
  console.log("BEN", benefitSuccess);

  useEffect(() => {
    if (formActive && detailEmployee) {
      // Auto-fill ketika modal dibuka
      FormPerson.setFieldsValue({
        number_id: detailEmployee.number_id,
        fullname: detailEmployee.fullName,
        date_of_birth: dayjs(detailEmployee.date_of_birth),
        place_of_birth: detailEmployee.place_of_birth,
        nationality: detailEmployee.nationality,
        gender: detailEmployee.gender,
        mother_name: detailEmployee.mother_name,
        npwp_number: detailEmployee.npwp_number,
        status_tax: detailEmployee.status_tax,
      });
      FormJob.setFieldsValue({
        title: detailEmployee.job,
        department: detailEmployee.department,
        type: detailEmployee.type,
        status: detailEmployee.status,
        organisation: detailEmployee.organisation,
        location: detailEmployee.location_name,
        report_to: `${detailEmployee.report_employee_id} - ( ${detailEmployee.report_to_name} )`,
        join_date: dayjs(detailEmployee.join_date),
        jamsostek_number: detailEmployee.jamsostek_number,
        bpjs_kesehatan: detailEmployee.bpjs_kesehatan,
        resign_date: detailEmployee.resign_date
          ? dayjs(detailEmployee.resign_date)
          : null,
      });
      FormContact.setFieldsValue({
        phone: detailEmployee.phone,
        email: detailEmployee.email,
        emergency_contact: {
          name: detailEmployee.emergency_contact?.name ? detailEmployee.emergency_contact.name : "",
          phone: detailEmployee.emergency_contact?.phone ? detailEmployee.emergency_contact.phone : "",
          status: detailEmployee.emergency_contact?.status ? detailEmployee.emergency_contact.status : "",
        },
        emergency_contact_second: {
          name: detailEmployee.emergency_contact_second?.name ? detailEmployee.emergency_contact_second.name : "",
          phone: detailEmployee.emergency_contact_second?.phone ? detailEmployee.emergency_contact_second.phone : "",
          status: detailEmployee.emergency_contact_second?.status ? detailEmployee.emergency_contact_second.status : "",
        },
        address_id: {
          street:
            detailEmployee.address !== null
              ? detailEmployee.address.street
              : "",
          city:
            detailEmployee.address !== null ? detailEmployee.address.city : "",
          postal_code:
            detailEmployee.address !== null
              ? detailEmployee.address.postal_code
              : "",
          country:
            detailEmployee.address !== null
              ? detailEmployee.address.country
              : "",
        },
        address_domicile: {
          street:
            detailEmployee.domicile !== null
              ? detailEmployee.domicile.street
              : "",
          city:
            detailEmployee.domicile !== null
              ? detailEmployee.domicile.city
              : "",
          postal_code:
            detailEmployee.domicile !== null
              ? detailEmployee.domicile.postal_code
              : "",
          country:
            detailEmployee.domicile !== null
              ? detailEmployee.domicile.country
              : "",
        },
      });
      FormBenefit.setFieldsValue(detailEmployee.benefit);
    }
  }, [formActive, detailEmployee]);

  useEffect(() => {
    // to do get more detail after any update
    dispatch(detailEmployeeRequest({ _id: eid }) as any);
    if (jobSuccess || personSuccess || contactSuccess || benefitSuccess) {
      setIsSuccess(true);
    }
  }, [jobChange, personChange, contactChange, benefitChange]);

  const renderDetailRow = (label: string, value: string | React.ReactNode) => (
    <Row gutter={16}>
      <Col span={6} style={{ marginBottom: "7px" }}>
        <strong style={{ fontFamily: "arial" }}>{label}</strong>
      </Col>
      <Col span={2}>:</Col>
      <Col span={8}>{jobLoading ? "updating..." : value}</Col>
    </Row>
  );

  const handleCancel = () => {
    setIsEditing(false);
    setEditingLevel(null);
    setOpenModal(false);
    setFormActive("");
    dispatch(resetJobSuccess());
    dispatch(resetJobMessage());
    dispatch(resetPersonMessage());
    dispatch(resetPersonSuccess());
    dispatch(resetBenefitMessage());
    dispatch(resetBenefitSuccess());
    dispatch(resetContactSuccess());
    dispatch(resetContactMessage());
    setIsSuccess(false);
    setButtonHide(false);
    FormPerson.resetFields();
    FormJob.resetFields();
  };
  console.log("DETAIL", detailEmployee);

  const showConfirmationModal = async (values: any, isAdd: boolean) => {
    console.log("V", values);
    console.log("Z", formActive);
    let formValues = null;
    if (formActive === "person") {
      formValues = await FormPerson.validateFields();
      formValues.date_of_birth = formValues.date_of_birth.format("YYYY-MM-DD");
      console.log("P", formValues);

      setUpdateField({ _id: detailEmployee.person_id, data: formValues });
      // console.log(formValues.date_of_birth.format("YYYY-MM-DD"));
    } else if (formActive === "job") {
      formValues = await FormJob.validateFields();
      const reportToValue =
        formValues.report_to ===
        `${detailEmployee.report_employee_id} - ( ${detailEmployee.report_to_name} )`
          ? detailEmployee.report_employee_id
          : formValues.report_to;

      const locationValue =
        formValues.location === detailEmployee.location_name
          ? detailEmployee.location_id
          : formValues.location;

      formValues.join_date = formValues.join_date.format("YYYY-MM-DD");
      formValues.resign_date = formValues.resign_date
        ? formValues.resign_date.format("YYYY-MM-DD")
        : null;

      console.log("Final Report To Value:", reportToValue);
      setUpdateField({
        _id: detailEmployee.job_id,
        data: {
          ...formValues,
          report_to: reportToValue,
          location: locationValue,
        },
      });
    } else if (formActive === "contact") {
      formValues = await FormContact.validateFields();
      console.log(formValues);
      setUpdateField({
        _id: detailEmployee.contact_id,
        data: formValues,
      });
    } else if (formActive === "benefit") {
      formValues = await FormBenefit.validateFields();
      setUpdateField({
        _id: detailEmployee.benefit_id,
        data: formValues,
      });
    }

    setOpenModal(true);
  };

  const handleModalOk = () => {
    setButtonHide(true);
    if (formActive === "job") {
      dispatch(updateJobRequest(updateField) as any);
      // onFinish(modalData);
    } else if (formActive === "person") {
      dispatch(updatePersonRequest(updateField) as any);
      // onFinishUpdate(modalData);
    } else if (formActive === "contact") {
      dispatch(updateContactRequest(updateField) as any);
      // onFinishUpdate(modalData);
    } else if (formActive === "benefit") {
      dispatch(updateBenefitRequest(updateField) as any);
      // onFinishUpdate(modalData);
    }
  };

  const editPersonForm = (
    <Form form={FormPerson} layout="vertical">
      <Form.Item name="number_id" label="Number ID">
        <Input />
      </Form.Item>
      <Form.Item name="fullname" label="Full Name">
        <Input />
      </Form.Item>
      <Form.Item name="mother_name" label="Mother Name">
        <Input />
      </Form.Item>
      <Form.Item name="npwp_number" label="NPWP Number">
        <Input />
      </Form.Item>
     
      <Form.Item name="status_tax" label="TAX Status" rules={[{ required: true }]}>
        <Select placeholder="Select Tax Type">
          <Select.Option value="TK0">TK0 - Tidak Menikah</Select.Option>
          <Select.Option value="K0">K0 - Menikah Anak 0 </Select.Option>
          <Select.Option value="K1">K1 - Menikah Anak 1 </Select.Option>
          <Select.Option value="K2">K2 - Menikah Anak 2 </Select.Option>
          <Select.Option value="K3">K3 - Menikah Anak 3 </Select.Option>
          
        </Select>
      </Form.Item>
      <Form.Item name="date_of_birth" label="Date of Birth">
        <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item name="place_of_birth" label="Place of Birth">
        <Input />
      </Form.Item>
      <Form.Item name="nationality" label="Nationality">
        <Input />
      </Form.Item>
      <Form.Item name="gender" label="Gender">
        <Radio.Group>
          <Radio value="male">Male</Radio>
          <Radio value="female">Female</Radio>
        </Radio.Group>
      </Form.Item>
      
    </Form>
  );

  // Modal untuk Edit Job (Contoh: Job)
  const editJobForm = (
    <Form layout="vertical" form={FormJob}>
      <Form.Item name="title" label="Level" rules={[{ required: true }]}>
        <Select
          showSearch
          placeholder="Search Level"
          optionFilterProp="children" // Pastikan pencarian menggunakan teks anak (name)
          filterOption={(input, option: any) =>
            option?.children?.toLowerCase().includes(input.toLowerCase())
          }
        >
          {levelData.map((level) => (
            <Select.Option key={level._id} value={level.name}>
              {level.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      {/* department form */}
      <Form.Item
        name="department"
        label="Department"
        rules={[{ required: true }]}
      >
        <Select
          showSearch
          placeholder="Search Department"
          optionFilterProp="children" // Pastikan pencarian menggunakan teks anak (name)
          filterOption={(input, option: any) =>
            option?.children?.toLowerCase().includes(input.toLowerCase())
          }
        >
          {departmentData.map((department) => (
            <Select.Option key={department._id} value={department.name}>
              {department.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name="join_date" label="Date of Join">
        <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
      </Form.Item>

      {/* Type */}
      <Form.Item name="type" label="Type" rules={[{ required: true }]}>
        <Select placeholder="Select type">
          <Select.Option value="full-time">Full-time</Select.Option>
          <Select.Option value="part-time">Part-time</Select.Option>
          <Select.Option value="contract">Contract</Select.Option>
        </Select>
      </Form.Item>

      {/* Status */}
      <Form.Item name="status" label="Status" rules={[{ required: true }]}>
        <Radio.Group>
          <Radio value="active">Active</Radio>
          <Radio value="inactive">Inactive</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item name="organisation" label="Organisation" rules={[{ required: true }]}>
        <Select
          showSearch
          placeholder="Search organisation"
          optionFilterProp="children" // Pastikan pencarian menggunakan teks anak (name)
          filterOption={(input, option: any) =>
            option?.children?.toLowerCase().includes(input.toLowerCase())
          }
        >
          {organisationData.map((org) => (
            <Select.Option key={org._id} value={org.name}>
              {org.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      {/* Location */}
      <Form.Item name="location" label="Location" rules={[{ required: true }]}>
        <Select
          showSearch
          placeholder="Search location"
          optionFilterProp="children" // Pastikan pencarian menggunakan teks anak (name)
          filterOption={(input, option: any) =>
            option?.children?.toLowerCase().includes(input.toLowerCase())
          }
        >
          {locationData.map((loc) => (
            <Select.Option key={loc._id} value={loc._id}>
              {loc.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      {/* Approval */}
      <Form.Item name="report_to" label="Approval" rules={[{ required: true }]}>
        <Select
          showSearch
          placeholder="Search approval"
          optionFilterProp="children"
          filterOption={(input, option: any) =>
            option?.children?.toLowerCase().includes(input.toLowerCase())
          }
        >
          {approvalData.map((approval) => (
            <Select.Option key={approval.code} value={approval.code}>
              {`${approval.code} - ( ${approval.name} )`}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name="resign_date" label="Date of Resign">
        <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item name="jamsostek_number" label="Jamsostek Number">
        <Input />
      </Form.Item>
      <Form.Item name="bpjs_kesehatan" label="BPJS Kesehatan">
        <Input />
      </Form.Item>
    </Form>
  );

  const editContactForm = (
    <Form
      layout="vertical"
      form={FormContact}
      // initialValues={initialData}
      // layout="vertical"
      // onFinish={onFinish}
    >
      <Form.Item
        label="Phone"
        name="phone"
        rules={[{ required: true, message: "Phone is required" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Email"
        name="email"
        rules={[{ required: true, message: "Email is required" }]}
      >
        <Input type="email" />
      </Form.Item>

      <div style={{border: "1px solid grey", borderRadius: 5, padding: 15, marginBottom:25}}>
        <h4 style={{color:"grey"}}>Emergency Contact 1</h4>
        <Form.Item  name={["emergency_contact", "name"]}>
          <Input placeholder="Name" />
        </Form.Item>
        <Form.Item name={["emergency_contact", "phone"]}>
          <Input placeholder="Phone" />
        </Form.Item>
        <Form.Item  name={["emergency_contact", "status"]}>
          <Input placeholder="Status" />
        </Form.Item>
      </div>

      <div style={{border: "1px solid grey", borderRadius: 5, padding: 15, marginBottom:20}}>
        <h4 style={{color:"grey"}}>Emergency Contact 2</h4>
        `  <Form.Item  name={["emergency_contact_second", "name"]}>
            <Input placeholder="Name" />
          </Form.Item>
          <Form.Item  name={["emergency_contact_second", "phone"]}>
            <Input placeholder="Phone" />
          </Form.Item>
          <Form.Item  name={["emergency_contact_second", "status"]}>
            <Input placeholder="Status" />
        </Form.Item>`
      </div>


      <Form.Item label="Street Address" name={["address_id", "street"]}>
        <Input />
      </Form.Item>

      <Form.Item label="City" name={["address_id", "city"]}>
        <Input />
      </Form.Item>

      <Form.Item label="Postal Code" name={["address_id", "postal_code"]}>
        <Input />
      </Form.Item>

      <Form.Item label="Country" name={["address_id", "country"]}>
        <Input />
      </Form.Item>

      <Form.Item label="Domicile Street" name={["address_domicile", "street"]}>
        <Input />
      </Form.Item>

      <Form.Item label="Domicile City" name={["address_domicile", "city"]}>
        <Input />
      </Form.Item>

      <Form.Item
        label="Domicile Postal Code"
        name={["address_domicile", "postal_code"]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Domicile Country"
        name={["address_domicile", "country"]}
      >
        <Input />
      </Form.Item>
    </Form>
  );

  const editBenefitForm = (
    <Form layout="vertical" form={FormBenefit}>
      <Form.Item name="healthInsurance" valuePropName="checked">
        <Checkbox>Health Insurance</Checkbox>
      </Form.Item>

      <Form.Item name="allowance" valuePropName="checked">
        <Checkbox>Allowance</Checkbox>
      </Form.Item>

      <Form.Item name="bpjsKesehatan" valuePropName="checked">
        <Checkbox>BPJS Kesehatan</Checkbox>
      </Form.Item>

      <Form.Item name="bpjsTenagaKerja" valuePropName="checked">
        <Checkbox>BPJS Tenaga Kerja</Checkbox>
      </Form.Item>

      <Form.Item name="bpjsHariTua" valuePropName="checked">
        <Checkbox>BPJS Hari Tua</Checkbox>
      </Form.Item>
    </Form>
  );

  return (
    <div style={{ marginTop: 20 }}>
      {detailEmployee && (
        <Row gutter={16}>
          <Col span={16}>
            {!loading ? (
              // <Table columns={columns} dataSource={levelList} rowKey="_id" />
              <div
                style={{
                  fontFamily: "arial",
                  backgroundColor: "#EEEEEE",
                  padding: 20,
                  borderColor: "#eaeaea",
                  borderStyle: "solid",
                  borderRadius: "7px",
                }}
              >
                <h2>Employee Details</h2>
                <Divider />

                <h3>Job Data</h3>
                <Divider />
                {renderDetailRow("EID", detailEmployee.eid)}
                {renderDetailRow("Organisation", detailEmployee.organisation || "-")}
                {renderDetailRow("Department", detailEmployee.department)}
                {renderDetailRow("Level", detailEmployee.job)}
                {renderDetailRow("Status", detailEmployee.status)}
                {renderDetailRow("Employment Type", detailEmployee.type)}
                {renderDetailRow(
                  "Approval Line",
                  `${detailEmployee.report_employee_id} - ( ${detailEmployee.report_to_name} )`
                )}
                {renderDetailRow("Location At", detailEmployee.location_name)}
                {renderDetailRow("Join Date", detailEmployee.join_date)}
                {renderDetailRow(
                  "Resign Date",
                  detailEmployee.resign_date || "NO-RESIGN"
                )}
                {renderDetailRow("JAMSOSTEK Number", detailEmployee.jamsostek_number || "-")}
                {renderDetailRow("BPJS Kesehatan", detailEmployee.bpjs_kesehatan || "-")}


                <Divider />
                <h3>Person Data</h3>
                <Divider />

                {renderDetailRow("Number ID", detailEmployee.number_id)}
                {renderDetailRow("Full Name", detailEmployee.fullName)}
                {renderDetailRow("Date of Birth", detailEmployee.date_of_birth)}
                {renderDetailRow(
                  "Place of Birth",
                  detailEmployee.place_of_birth
                )}
                {renderDetailRow("Nationality", detailEmployee.nationality)}
                {renderDetailRow("Gender", detailEmployee.gender)}
                {renderDetailRow(
                  "Martial Status",
                  detailEmployee.marital_status
                )}
                {renderDetailRow("Religion", detailEmployee.religion)}
                {renderDetailRow("Mother Name", detailEmployee.mother_name || "-")}
                {renderDetailRow("NPWP Number", detailEmployee.npwp_number || "-")}
                {renderDetailRow("TAX Status", detailEmployee.status_tax || "-")}

                

                <Divider />
                <h3>Contact Data</h3>
                <Divider />
                {renderDetailRow("Phone", detailEmployee.phone)}
                {renderDetailRow("Email", detailEmployee.email)}
                {renderDetailRow("Emergency Contact 1", <div style={{marginBottom: 10}}>
                  {renderDetailRow("Name", detailEmployee.emergency_contact?.name || "-")}
                  {renderDetailRow("Phone", detailEmployee.emergency_contact?.phone || "-")}
                  {renderDetailRow("Status", detailEmployee.emergency_contact?.status || "-")}
                </div>)}
                {renderDetailRow("Emergency Contact 2", <div style={{marginBottom: 10}}>
                  {renderDetailRow("Name", detailEmployee.emergency_contact_second?.name || "-")}
                  {renderDetailRow("Phone", detailEmployee.emergency_contact_second?.phone || "-")}
                  {renderDetailRow("Status", detailEmployee.emergency_contact_second?.status || "-")}
                </div>)}
                
                {renderDetailRow(
                  "Country",
                  detailEmployee.address?.country || "NONE"
                )}
                {renderDetailRow(
                  "ID City",
                  detailEmployee.address?.city || "NONE"
                )}

                {renderDetailRow(
                  "Street",
                  detailEmployee.address?.street || "NONE"
                )}
                {renderDetailRow(
                  "Postal Code",
                  detailEmployee.address?.postal_code || "NONE"
                )}
                {renderDetailRow(
                  "Domicile Country",
                  detailEmployee.domicile?.country || "NONE"
                )}
                {renderDetailRow(
                  "Domicile City",
                  detailEmployee.domicile?.city || "NONE"
                )}
                {renderDetailRow(
                  "Domicile Street",
                  detailEmployee.domicile?.stress || "NONE"
                )}
                {renderDetailRow(
                  "Domicile Postal Code",
                  detailEmployee.domicile?.postal_code || "NONE"
                )}
              </div>
            ) : (
              <Skeleton active />
            )}
          </Col>

          <Col span={8}>
            <div
              style={{
                paddingLeft: 10,
              }}
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Button
                    type="primary"
                    block
                    onClick={() => {
                      setIsEditing(true);
                      setFormActive("person");
                    }}
                    // style={{ marginTop: "50px", marginBottom: "10px" }}
                  >
                    Edit Person
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    type="primary"
                    block
                    onClick={() => {
                      setIsEditing(true);
                      setFormActive("job");
                    }}
                    // style={{ marginTop: "50px", marginBottom: "10px" }}
                  >
                    Edit Job
                  </Button>
                </Col>
              </Row>
              <Row gutter={16} style={{ marginTop: 8, marginBottom: 20 }}>
                <Col span={12}>
                  <Button
                    type="primary"
                    block
                    onClick={() => {
                      setIsEditing(true);
                      setFormActive("contact");
                    }}
                    // style={{ marginTop: "50px", marginBottom: "10px" }}
                  >
                    Edit Contact
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    type="primary"
                    block
                    onClick={() => {
                      setIsEditing(true);
                      setFormActive("benefit");
                    }}
                    // style={{ marginTop: "50px", marginBottom: "10px" }}
                  >
                    Edit Benefit
                  </Button>
                </Col>
              </Row>
            </div>

            {isEditing && (
              <div
                style={{
                  backgroundColor: "#E4E0E1",
                  marginTop: 15,
                  marginLeft: 10,
                  borderColor: "#eaeaea",
                  borderStyle: "solid",
                  borderRadius: "7px",
                  padding: 20,
                }}
              >
                <h4>EDIT {formActive.toUpperCase()}</h4>
                <Form
                  // form={formEdit}
                  layout="vertical"
                  onFinish={(values) =>
                    showConfirmationModal(
                      { ...editingLevel, ...values },
                      !isEditing
                    )
                  }
                  initialValues={editingLevel || {}}
                  style={{ maxWidth: 400 }}
                >
                  {/* <Form.Item
                label="Level Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please input the level name!",
                  },
                ]}
              >
                <Input />
              </Form.Item> */}
                  {formActive === "person" && editPersonForm}
                  {formActive === "job" && editJobForm}
                  {formActive === "benefit" && editBenefitForm}
                  {formActive === "contact" && editContactForm}

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{
                        marginRight: 20,
                        backgroundColor: "#faad14",
                        borderColor: "#faad14",
                      }}
                    >
                      Update
                    </Button>
                    <Button onClick={handleCancel}>Cancel & Close</Button>
                  </Form.Item>
                </Form>
              </div>
            )}
          </Col>
        </Row>
      )}

      <Modal
        open={openModal}
        title="Confirm Action"
        onCancel={handleCancel}
        cancelText="Close"
        onOk={handleModalOk}
        okButtonProps={buttonHide ? { style: { display: "none" } } : {}}
      >
        <p>
          {formActive === "job"
            ? "Are you sure you want to edit this employee job?"
            : formActive === "person"
            ? "Are you sure you want to edit this employee person?"
            : ""}
        </p>
        {isLoading && (
          <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
        )}
        {isSuccess && (
          <Result status="success" title="Successfully to Request" />
        )}
        {message.length > 0 && (
          <Result
            status="warning"
            title={
              jobMessage || personMessage || benefitMessage || contactMessage
            }
          />
        )}
      </Modal>
    </div>
  );
};

export default DetailEmployee;
